"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ticket_1 = require("@pbl/pbl-react-core/lib/models/ticket");
var types_1 = require("@pbl/pbl-react-core/lib/models/ticket/types");
var constants_1 = __importDefault(require("../../../config/constants"));
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    ticketNumber: '',
    validationCode: '',
    tabKey: '',
    loading: false,
    errorMessage: null,
    prizes: new ticket_1.TicketSubmissionPrizeDTOList(),
    graphicImageUrl: null,
    drawTicketValidation: null,
    instantTicketValidation: null,
    instantCashResponse: null,
    onlineCashResponse: null,
    ticketValidation: null
};
exports.default = (function (state, action) {
    var _a;
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_1.ENTER_TICKET):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(types_1.ENTER_TICKET):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, prizes: action.payload && action.payload.prizes
                    ? action.payload.prizes
                    : new ticket_1.TicketSubmissionPrizeDTOList(), graphicImageUrl: action.payload.graphicImageUrl, ticketNumber: '', validationCode: '' });
        case (0, action_type_util_1.FAILURE)(types_1.ENTER_TICKET):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload && action.payload.payload
                    ? constants_1.default.V2_CHANGES
                        ? action.payload.payload.error
                        : action.payload.payload
                    : action.payload.error, graphicImageUrl: null, ticketNumber: !constants_1.default.RESET_FIELDS_AFTER_SUBMIT_TICKET && action.payload.ticketBarcodeNumber
                    ? action.payload.ticketBarcodeNumber
                    : '', validationCode: !constants_1.default.RESET_FIELDS_AFTER_SUBMIT_TICKET && action.payload.validationNumber
                    ? action.payload.validationNumber
                    : '', tabKey: !constants_1.default.RESET_FIELDS_AFTER_SUBMIT_TICKET && action.payload.tabKey
                    ? action.payload.tabKey
                    : '' });
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAWS_BY_IDS):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload && action.payload.payload ? action.payload.payload : action.payload, graphicImageUrl: null });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAWS_BY_IDS):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, prizes: action.payload && action.payload.length > 0 ? action.payload : state.prizes });
        case types_1.UPDATE_ATTR:
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.attr] = action.payload.value, _a));
        case types_1.RESET:
            return __assign({}, INITIAL_STATE);
        case types_1.CLEAR_ERROR:
            return __assign(__assign({}, state), { errorMessage: null });
        case types_1.CLEAR_PRIZES:
            return __assign(__assign({}, state), { prizes: new ticket_1.TicketSubmissionPrizeDTOList(), graphicImageUrl: null });
        default:
            return state;
    }
});
//# sourceMappingURL=reducers.js.map